import {
  AfterContentInit,
  Component,
  ContentChildren,
  Inject,
  Input,
  QueryList,
} from '@angular/core';
import { componentStylesByTheme } from '../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../types/theme.types';
import { menuStylesSAG, menuStylesSHS } from './menu.styles';
import { MenuItemComponent } from './menu-item/menu-item.component';

@Component({
  selector: 'sag-ui-menu',
  template: `
    <div [class]="styles" popover [id]="menu">
      <ng-content></ng-content>
    </div>
  `,
})
export class MenuComponent implements AfterContentInit {
  @Input() class = '';
  @Input() menu = '';
  @Input() root?: string;

  @ContentChildren(MenuItemComponent)
  menuItems!: QueryList<MenuItemComponent>;

  @ContentChildren(MenuComponent)
  nestedMenus!: QueryList<MenuComponent>;

  constructor(@Inject(THEME_TOKEN) private readonly theme: Theme) {}

  ngAfterContentInit(): void {
    this.initMenuItems();
    this.initNestedMenus();
  }

  private initMenuItems(): void {
    this.menuItems.forEach((item) => {
      item.click = () => {
        const menuElement = document.getElementById(this.root ?? this.menu);
        if (!menuElement) return;

        menuElement.hidePopover();
      };

      item.mouseenter = () => {
        this.nestedMenus.forEach((menu) => {
          const menuElement = document.getElementById(menu.menu);
          if (!menuElement) return;

          menuElement.hidePopover();
        });
      };
    });
  }

  private initNestedMenus(): void {
    this.nestedMenus.forEach((menu) => {
      menu.root = this.root ?? this.menu;
    });
  }

  protected get styles() {
    return (
      componentStylesByTheme(this.theme, menuStylesSAG, menuStylesSHS)() +
      (this.class ? ` ${this.class}` : '')
    );
  }
}
